import React, { useState, useRef } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster,
  CRow,
  CCol,
  CFormTextarea,
} from "@coreui/react";

const NewBookingOrderActionModal = ({
  visible,
  setVisibleNewBookingOrderActionModal,
  addToast,
  onConfirm,
  text,
  selectedOption,
  errorText,
  handleReportComment,
  reportComment,
}) => {
  const exampleToast = (
    <CToast>
      <CToastHeader closeButton>
        <svg
          className="rounded me-2"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
        >
          <rect width="100%" height="100%" fill="#007aff"></rect>
        </svg>
        <div className="fw-bold me-auto">CoreUI for React.js</div>
        <small>7 min ago</small>
      </CToastHeader>
      <CToastBody>Hello, world! This is a toast message.</CToastBody>
    </CToast>
  );
  const closeModal = () => {
    setVisibleNewBookingOrderActionModal(false);
  };
  const deleteFn = () => {
    addToast(exampleToast);
    setVisibleNewBookingOrderActionModal(false);
  };
  return (
    <div>
      <CModal
        backdrop="static"
        visible={visible}
        onClose={() => {
          onConfirm("cancel");
        }}
      >
        <CModalHeader onClose={() => onConfirm("cancel")}>
          <CModalTitle>Confirmation Modal</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {text ? text : "You are sure to delete this!!"}
          {selectedOption === "rejected" ? (
            <CRow className="mb-3">
              <CCol sm={12}>
                <CFormTextarea
                  id="exampleFormControlTextarea1"
                  rows={3}
                  onChange={(e) => handleReportComment(e.target.value)}
                  value={reportComment}
                ></CFormTextarea>
                {errorText ? <p className="error_text">{errorText}</p> : ""}
              </CCol>
            </CRow>
          ) : (
            ""
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => onConfirm("cancel")}>
            Close
          </CButton>
          {selectedOption === "rejected" ? (
            <CButton
              color="danger text-white"
              onClick={() => onConfirm("confirm")}
              disabled={!reportComment}
            >
              Submit
            </CButton>
          ) : (
            <CButton onClick={() => onConfirm("confirm")}>Confirm</CButton>
          )}
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default NewBookingOrderActionModal;
